/**
 * VOBVOROT Cart, Wishlist & Music Player Integration
 * Migrated from vobvorot.com production site
 */

// ================================
// MUSIC PLAYER
// ================================

const MUSIC_TRACKS = [
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3", title: "Ambient Track 1" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3", title: "Ambient Track 2" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3", title: "Ambient Track 3" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3", title: "Ambient Track 4" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3", title: "Ambient Track 5" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3", title: "Ambient Track 6" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-7.mp3", title: "Ambient Track 7" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3", title: "Ambient Track 8" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-9.mp3", title: "Ambient Track 9" },
  { audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-10.mp3", title: "Ambient Track 10" }
];

class MusicPlayer {
  constructor() {
    this.audio = document.getElementById('music-audio');
    this.tracks = this.shuffleArray([...MUSIC_TRACKS]);
    this.currentTrackIndex = 0;
    this.isPlaying = false;
    this.volume = 0.3;
    this.isExpanded = false;

    // Генерируем уникальный Session ID для этой вкладки
    this.sessionId = sessionStorage.getItem('musicPlayerSessionId');
    if (!this.sessionId) {
      this.sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('musicPlayerSessionId', this.sessionId);
    }

    this.init();
  }

  shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  init() {
    // ВАЖНО: Используем sessionStorage вместо localStorage
    // Это изолирует каждую вкладку/браузер и решает проблему #2
    const savedState = sessionStorage.getItem('musicPlayerState_' + this.sessionId);
    let savedTime = 0;
    let wasPlaying = false;
    let savedTrackUrl = null;

    if (savedState) {
      const state = JSON.parse(savedState);
      savedTrackUrl = state.currentTrackUrl || null;
      this.volume = state.volume || 0.3;
      this.isExpanded = state.isExpanded || false;
      savedTime = state.currentTime || 0;
      wasPlaying = state.isPlaying || false;

      // Найти индекс трека по URL (важно для перемешанного порядка)
      if (savedTrackUrl) {
        const trackIndex = this.tracks.findIndex(track => track.audioUrl === savedTrackUrl);
        this.currentTrackIndex = trackIndex !== -1 ? trackIndex : 0;
      } else {
        // Fallback на старый метод если URL не сохранен
        this.currentTrackIndex = state.currentTrackIndex || 0;
      }
    }

    // Set initial volume
    this.audio.volume = this.volume;
    document.getElementById('music-volume').value = this.volume * 100;
    document.getElementById('music-volume-value').textContent = Math.round(this.volume * 100) + '%';

    // Оптимизация для минимизации паузы при переходе
    this.audio.preload = 'auto';  // Предзагрузка аудио

    // Load first track
    this.loadTrack(this.currentTrackIndex);

    // Set up event listeners
    this.setupEventListeners();

    // Restore expanded state
    if (this.isExpanded) {
      this.expand();
    }

    // Restore playback position and auto-play if was playing
    // Используем Promise для более быстрого восстановления
    if (wasPlaying) {
      this.audio.addEventListener('loadedmetadata', () => {
        if (savedTime > 0) {
          this.audio.currentTime = savedTime;
        }
        // Немедленный play без ожидания
        this.play().catch(err => {
          console.warn('Autoplay blocked by browser:', err);
        });
      }, { once: true });

      // Fallback - если metadata уже загружена
      if (this.audio.readyState >= 1) {
        if (savedTime > 0) {
          this.audio.currentTime = savedTime;
        }
        this.play().catch(err => {
          console.warn('Autoplay blocked by browser:', err);
        });
      }
    }
  }

  setupEventListeners() {
    // Toggle expand/collapse
    document.getElementById('music-player-toggle').addEventListener('click', () => {
      this.toggleExpand();
    });

    document.getElementById('music-player-close').addEventListener('click', () => {
      this.collapse();
    });

    // Playback controls
    document.getElementById('music-play-pause').addEventListener('click', () => {
      this.togglePlayPause();
    });

    document.getElementById('music-prev').addEventListener('click', () => {
      this.previousTrack();
    });

    document.getElementById('music-next').addEventListener('click', () => {
      this.nextTrack();
    });

    // Volume control
    document.getElementById('music-volume').addEventListener('input', (e) => {
      this.setVolume(e.target.value / 100);
    });

    // Auto-advance when track ends
    this.audio.addEventListener('ended', () => {
      this.nextTrack();
    });

    // Update progress bar + periodic state save
    this.audio.addEventListener('timeupdate', () => {
      this.updateProgress();
      // Периодически сохраняем позицию (каждые 2 секунды)
      if (Math.floor(this.audio.currentTime) % 2 === 0) {
        this.saveState();
      }
    });

    // Save state before page unload
    window.addEventListener('beforeunload', () => {
      this.saveState();
    });
  }

  loadTrack(index) {
    const track = this.tracks[index];

    // Оптимизация: Если это тот же трек что был загружен - не перезагружаем
    if (this.audio.src === track.audioUrl) {
      console.log('🎵 Same track, skipping reload');
      return;
    }

    this.audio.src = track.audioUrl;
    // Track title removed from UI
    this.saveState();
  }

  togglePlayPause() {
    if (this.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  }

  play() {
    const playPromise = this.audio.play();
    this.isPlaying = true;
    document.getElementById('music-play-pause').textContent = '⏸️';
    document.querySelector('.music-visualizer').classList.add('playing');
    this.saveState(); // Сохраняем состояние при включении

    // ВАЖНО: Уведомляем видео о том, что музыка началась
    window.dispatchEvent(new CustomEvent('spa:musicPlayerStateChanged', {
      detail: {
        isPlaying: true,
        currentTime: this.audio.currentTime,
        trackIndex: this.currentTrackIndex
      }
    }));

    return playPromise; // Возвращаем Promise для обработки ошибок autoplay
  }

  pause() {
    this.audio.pause();
    this.isPlaying = false;
    document.getElementById('music-play-pause').textContent = '▶️';
    document.querySelector('.music-visualizer').classList.remove('playing');
    this.saveState(); // Сохраняем состояние при паузе

    // ВАЖНО: Уведомляем видео о том, что музыка остановлена
    window.dispatchEvent(new CustomEvent('spa:musicPlayerStateChanged', {
      detail: {
        isPlaying: false,
        currentTime: this.audio.currentTime,
        trackIndex: this.currentTrackIndex
      }
    }));
  }

  nextTrack() {
    this.currentTrackIndex = (this.currentTrackIndex + 1) % this.tracks.length;
    this.loadTrack(this.currentTrackIndex);
    if (this.isPlaying) {
      this.play();
    }
  }

  previousTrack() {
    this.currentTrackIndex = (this.currentTrackIndex - 1 + this.tracks.length) % this.tracks.length;
    this.loadTrack(this.currentTrackIndex);
    if (this.isPlaying) {
      this.play();
    }
  }

  setVolume(value) {
    this.volume = value;
    this.audio.volume = value;
    document.getElementById('music-volume-value').textContent = Math.round(value * 100) + '%';
    this.saveState();
  }

  updateProgress() {
    if (this.audio.duration) {
      const progress = (this.audio.currentTime / this.audio.duration) * 100;
      document.getElementById('music-progress-bar').style.width = progress + '%';
    }
  }

  toggleExpand() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.isExpanded = true;
    document.getElementById('music-player-toggle').style.display = 'none';
    document.getElementById('music-player-expanded').style.display = 'block';
    this.saveState();
  }

  collapse() {
    this.isExpanded = false;
    document.getElementById('music-player-toggle').style.display = 'flex';
    document.getElementById('music-player-expanded').style.display = 'none';
    this.saveState();
  }

  saveState() {
    // ВАЖНО: Используем sessionStorage с уникальным session ID
    // Это изолирует каждую вкладку/браузер
    sessionStorage.setItem('musicPlayerState_' + this.sessionId, JSON.stringify({
      currentTrackIndex: this.currentTrackIndex,
      currentTrackUrl: this.tracks[this.currentTrackIndex]?.audioUrl || null,  // Сохраняем URL трека
      volume: this.volume,
      isExpanded: this.isExpanded,
      isPlaying: this.isPlaying,  // Сохраняем статус воспроизведения
      currentTime: this.audio.currentTime || 0  // Сохраняем позицию в треке
    }));
  }
}

// ================================
// WISHLIST MANAGEMENT
// ================================

class WishlistManager {
  constructor() {
    this.items = [];
    this.showedWarning = false;
    this.loadFromStorage();
    this.showStorageWarning();
  }

  loadFromStorage() {
    // ФИКС #7: Используем sessionStorage вместо localStorage
    // sessionStorage очищается при закрытии вкладки, НЕ сохраняется между сессиями
    const saved = sessionStorage.getItem('vobvorot_wishlist');
    if (saved) {
      this.items = JSON.parse(saved);
    }
    this.updateBadge();
  }

  saveToStorage() {
    // ФИКС #7: Используем sessionStorage
    sessionStorage.setItem('vobvorot_wishlist', JSON.stringify(this.items));
    this.updateBadge();
  }

  showStorageWarning() {
    // Показываем предупреждение один раз за сессию
    if (!this.showedWarning && sessionStorage.getItem('wishlist_warning_shown') !== 'true') {
      console.warn('⚠️ WISHLIST NOTICE: Items are saved in session only (cleared when you close the tab)');
      sessionStorage.setItem('wishlist_warning_shown', 'true');
      this.showedWarning = true;
    }
  }

  addItem(product) {
    if (!this.isInWishlist(product.id)) {
      // ФИКС #3: Правильная структура данных с фото
      // ФИКС: Добавляем variantId для корректной работы Move to Cart
      this.items.push({
        id: product.id,
        variantId: product.variants?.[0]?.id || product.variant_id || null,
        name: product.title,
        slug: product.handle,
        price: product.price,
        brand: product.vendor || '',
        // ВАЖНО: правильный формат фото
        images: [{ url: product.featured_image, alt: product.title }],
        addedAt: new Date().toISOString()
      });
      this.saveToStorage();
      console.log('✅ Product added to wishlist:', product.title, 'variantId:', product.variants?.[0]?.id || product.variant_id);
      return true;
    }
    console.log('ℹ️ Product already in wishlist:', product.title);
    return false;
  }

  removeItem(productId) {
    this.items = this.items.filter(item => item.id !== productId);
    this.saveToStorage();
  }

  isInWishlist(productId) {
    return this.items.some(item => item.id === productId);
  }

  getItems() {
    return this.items;
  }

  updateBadge() {
    const badge = document.getElementById('wishlist-count-badge');
    if (this.items.length > 0) {
      badge.textContent = this.items.length;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  renderWishlist() {
    const container = document.getElementById('wishlist-items-container');

    if (this.items.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <div class="wishlist-empty-icon">💫</div>
          <div class="wishlist-empty-title">Your wishlist is empty</div>
        </div>
      `;
      return;
    }

    container.innerHTML = this.items.map(item => `
      <div class="wishlist-item" data-product-id="${item.id}">
        <img src="${item.images[0]?.url || ''}" alt="${item.name}" class="wishlist-item-image">
        <div class="wishlist-item-details">
          <div class="wishlist-item-title">${item.name}</div>
          ${item.brand ? `<div class="wishlist-item-brand">${item.brand}</div>` : ''}
          <div class="wishlist-item-price">$${(item.price / 100).toFixed(2)}</div>
          <div class="wishlist-item-date">Added ${this.formatDate(item.addedAt)}</div>
          <div class="wishlist-actions">
            <button class="move-to-cart-btn" data-product-id="${item.id}">
              Move to Cart
            </button>
            <button class="remove-from-wishlist-btn" data-product-id="${item.id}">
              Remove
            </button>
          </div>
        </div>
      </div>
    `).join('');

    // Add event listeners
    container.querySelectorAll('.move-to-cart-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const productId = e.target.dataset.productId;
        this.moveToCart(productId);
      });
    });

    container.querySelectorAll('.remove-from-wishlist-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const productId = e.target.dataset.productId;
        this.removeItem(productId);
        this.renderWishlist();
      });
    });
  }

  async moveToCart(productId) {
    const item = this.items.find(i => i.id === productId);
    if (!item) return;

    try {
      // ФИКС: Используем variantId вместо productId для Shopify Cart API
      let variantId = item.variantId;

      // Если variantId не сохранен (старые записи), получаем через API
      if (!variantId && item.slug) {
        console.log('⏳ Fetching variant ID for:', item.slug);
        const productResponse = await fetch(`/products/${item.slug}.js`);
        if (productResponse.ok) {
          const productData = await productResponse.json();
          variantId = productData.variants[0]?.id;
          console.log('✅ Got variant ID:', variantId);
        }
      }

      if (!variantId) {
        console.error('❌ Could not get variant ID for product:', item.name);
        alert('Could not add to cart. Please try from the product page.');
        return;
      }

      // Add to Shopify cart with correct variant ID
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      if (response.ok) {
        console.log('✅ Moved to cart:', item.name);
        this.removeItem(productId);
        this.renderWishlist();
        // Refresh cart
        if (window.cartManager) {
          await window.cartManager.refreshCart();
        }
        // Dispatch event for quick-add button sync
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        const errorData = await response.text();
        console.error('❌ Cart add failed:', response.status, errorData);
        alert('Failed to add to cart. The item may be sold out.');
      }
    } catch (error) {
      console.error('Error moving to cart:', error);
      alert('Failed to move item to cart. Please try again.');
    }
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date.toLocaleDateString();
  }
}

// ================================
// CART MANAGEMENT
// ================================

class CartManager {
  constructor() {
    this.cart = null;
    this.init();
  }

  async init() {
    // ФИКС #7: Очистка корзины при новой сессии
    // Проверяем флаг в sessionStorage - если его нет, это новая сессия
    if (!sessionStorage.getItem('vobvorot_cart_session_initialized')) {
      console.log('🔄 New session detected - clearing server-side cart');
      await this.clearServerCart();
      sessionStorage.setItem('vobvorot_cart_session_initialized', 'true');
    }

    await this.refreshCart();
  }

  async clearServerCart() {
    try {
      // Очищаем серверную корзину Shopify
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.ok) {
        console.log('✅ Server cart cleared successfully');
        return true;
      } else {
        console.warn('⚠️ Failed to clear server cart:', response.status);
        return false;
      }
    } catch (error) {
      console.error('❌ Error clearing server cart:', error);
      return false;
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      this.updateBadge();
      return this.cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  updateBadge() {
    const badge = document.getElementById('cart-count-badge');
    if (this.cart && this.cart.item_count > 0) {
      badge.textContent = this.cart.item_count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  async addItem(variantId, quantity = 1) {
    console.log('📦 CartManager.addItem called with:', { variantId, quantity, type: typeof variantId });

    try {
      const requestData = {
        items: [{ id: variantId, quantity }]
      };
      console.log('📦 Request data:', JSON.stringify(requestData));

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
      });

      console.log('📦 Response status:', response.status, response.statusText);

      if (response.ok) {
        const responseData = await response.json();
        console.log('📦 Response data:', responseData);
        await this.refreshCart();
        console.log('✅ Cart refreshed, item count:', this.cart?.item_count);
        return true;
      } else {
        const errorData = await response.text();
        console.error('❌ Cart add failed:', response.status, errorData);
        return false;
      }
    } catch (error) {
      console.error('❌ Error adding to cart:', error);
      console.error('❌ Error stack:', error.stack);
      return false;
    }
  }

  async updateQuantity(lineIndex, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineIndex,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.refreshCart();
        this.renderCart();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error updating cart:', error);
      return false;
    }
  }

  async removeItem(lineIndex) {
    return this.updateQuantity(lineIndex, 0);
  }

  renderCart() {
    const container = document.getElementById('cart-items-container');
    const totalSection = document.getElementById('cart-total-section');

    if (!this.cart || this.cart.item_count === 0) {
      container.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">🛒</div>
          <div class="cart-empty-title">Your cart is empty</div>
        </div>
      `;
      totalSection.style.display = 'none';
      return;
    }

    container.innerHTML = this.cart.items.map((item, index) => {
      // ФИКС #2 (IMPROVED): Правильная логика для quantity controls
      // Скрываем +/- кнопки если товар в единственном экземпляре

      // Определяем максимально доступное количество
      const maxAvailable = item.variant_inventory_management && item.variant_inventory_quantity !== null
        ? item.variant_inventory_quantity
        : 999; // Если inventory не отслеживается - допускаем большое количество

      // Можно уменьшить только если quantity > 1
      const canDecrease = item.quantity > 1;

      // Можно увеличить только если есть остаток на складе
      const canIncrease = item.quantity < maxAvailable;

      // Скрываем ОБЕ кнопки (+/-) если товар в единственном экземпляре
      const showQuantityButtons = maxAvailable > 1 || item.quantity > 1;

      return `
        <div class="cart-item" data-line="${index + 1}">
          <img src="${item.featured_image?.url || item.image}" alt="${item.title}" class="cart-item-image">
          <div class="cart-item-details">
            <div class="cart-item-title">${item.product_title}</div>
            ${item.variant_title ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-item-price">$${(item.final_line_price / 100).toFixed(2)}</div>
            <div class="cart-item-actions-row">
              <div class="quantity-badge">
                <span class="qty-icon">📦</span>
                <span class="qty-text">QTY</span>
                <span class="qty-number">${item.quantity}</span>
              </div>
              <button class="remove-btn-styled" data-line="${index + 1}">
                <span class="remove-icon">🗑️</span>
                <span class="remove-text">Remove</span>
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Update total
    document.getElementById('cart-total-price').textContent = `$${(this.cart.total_price / 100).toFixed(2)}`;
    totalSection.style.display = 'block';

    // Add event listeners
    container.querySelectorAll('.remove-btn-styled').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const line = parseInt(e.target.closest('.remove-btn-styled').dataset.line);
        this.removeItem(line);
      });
    });
  }

  // ФИКС #4: Переход на страницу корзины вместо checkout
  openCheckout() {
    window.location.href = '/cart';
  }
}

// ================================
// MODAL CONTROLS
// ================================

class ModalController {
  constructor() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Cart modal
    document.getElementById('floating-cart-btn').addEventListener('click', () => {
      this.openCartModal();
    });

    document.getElementById('close-cart-modal').addEventListener('click', () => {
      this.closeCartModal();
    });

    document.getElementById('cart-backdrop').addEventListener('click', () => {
      this.closeCartModal();
    });

    // Wishlist modal
    document.getElementById('floating-wishlist-btn').addEventListener('click', () => {
      this.openWishlistModal();
    });

    document.getElementById('close-wishlist-modal').addEventListener('click', () => {
      this.closeWishlistModal();
    });

    document.getElementById('wishlist-backdrop').addEventListener('click', () => {
      this.closeWishlistModal();
    });

    // Checkout button
    document.getElementById('checkout-btn').addEventListener('click', () => {
      if (window.cartManager) {
        window.cartManager.openCheckout();
      }
    });
  }

  openCartModal() {
    if (window.cartManager) {
      window.cartManager.renderCart();
    }
    document.getElementById('cart-modal').style.display = 'flex';
    document.getElementById('cart-backdrop').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  closeCartModal() {
    document.getElementById('cart-modal').style.display = 'none';
    document.getElementById('cart-backdrop').style.display = 'none';
    document.body.style.overflow = '';
  }

  openWishlistModal() {
    if (window.wishlistManager) {
      window.wishlistManager.renderWishlist();
    }
    document.getElementById('wishlist-modal').style.display = 'flex';
    document.getElementById('wishlist-backdrop').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  closeWishlistModal() {
    document.getElementById('wishlist-modal').style.display = 'none';
    document.getElementById('wishlist-backdrop').style.display = 'none';
    document.body.style.overflow = '';
  }
}

// ================================
// NAVIGATION SIDEBAR
// ================================

class NavigationController {
  constructor() {
    this.sidebar = document.getElementById('navigation-sidebar');
    this.backdrop = document.getElementById('nav-backdrop');
    this.toggleBtn = document.getElementById('nav-toggle');
    this.closeBtn = document.getElementById('nav-close');
    this.navCartBtn = document.getElementById('nav-cart-btn');
    this.navWishlistBtn = document.getElementById('nav-wishlist-btn');

    this.init();
  }

  init() {
    // Toggle button - 🔥 ИСПРАВЛЕНИЕ: теперь переключает open/close вместо только open
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.toggle());
    }

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Backdrop
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }

    // Cart button in nav
    if (this.navCartBtn) {
      this.navCartBtn.addEventListener('click', () => {
        this.close();
        if (window.modalController) {
          window.modalController.openCart();
        }
      });
    }

    // Wishlist button in nav
    if (this.navWishlistBtn) {
      this.navWishlistBtn.addEventListener('click', () => {
        this.close();
        if (window.modalController) {
          window.modalController.openWishlist();
        }
      });
    }

    // 🔥 ИСПРАВЛЕНИЕ: Автозакрытие меню при клике на навигационные ссылки (2025-01-19)
    // Проблема: меню остается открытым при переходе на другую страницу
    // Решение: Добавляем обработчики на ВСЕ навигационные <a> ссылки
    this.setupNavLinkHandlers();

    // Update badges
    this.updateBadges();

    // Update badges when cart/wishlist changes
    setInterval(() => this.updateBadges(), 1000);
  }

  // 🔥 НОВЫЙ МЕТОД: Настройка обработчиков для навигационных ссылок
  setupNavLinkHandlers() {
    if (!this.sidebar) {
      console.warn('[Nav] Sidebar не найден - пропускаем setup nav links');
      return;
    }

    // Находим ВСЕ элементы с классом .nav-link внутри sidebar
    const navLinks = this.sidebar.querySelectorAll('.nav-link');
    console.log(`[Nav] Найдено ${navLinks.length} элементов с классом .nav-link`);

    let linkCount = 0;
    navLinks.forEach((link, index) => {
      // Добавляем обработчик на ВСЕ nav-link элементы (ссылки И кнопки)
      link.addEventListener('click', () => {
        console.log('[Nav] Клик на навигационный элемент - закрываем меню');
        this.close();
      });
      linkCount++;
      console.log(`[Nav] Добавлен обработчик на элемент #${index + 1}: ${link.textContent.trim()}`);
    });

    // Также добавляем обработчик на country selector (select элемент)
    const countrySelect = this.sidebar.querySelector('.country-selector__select');
    if (countrySelect) {
      countrySelect.addEventListener('change', () => {
        console.log('[Nav] Country changed - закрываем меню');
        this.close();
      });
      console.log('[Nav] Добавлен обработчик на country selector');
    }

    console.log(`[Nav] ✅ Успешно добавлено ${linkCount} обработчиков на навигационные элементы`);
  }

  // 🔥 НОВЫЙ МЕТОД: Toggle между open и close
  toggle() {
    if (this.sidebar && this.sidebar.classList.contains('active')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.sidebar) {
      this.sidebar.classList.add('active');
    }
    if (this.backdrop) {
      this.backdrop.classList.add('active');
    }
    // ИСПРАВЛЕНИЕ: Скрываем кнопку гамбургера когда меню открыто
    // чтобы не было двух крестиков (один работающий, один нет)
    if (this.toggleBtn) {
      this.toggleBtn.style.display = 'none';
    }
  }

  close() {
    if (this.sidebar) {
      this.sidebar.classList.remove('active');
    }
    if (this.backdrop) {
      this.backdrop.classList.remove('active');
    }
    // ИСПРАВЛЕНИЕ: Показываем кнопку гамбургера обратно когда меню закрыто
    if (this.toggleBtn) {
      this.toggleBtn.style.display = 'flex';
    }
  }

  updateBadges() {
    // Update cart count
    const navCartCount = document.getElementById('nav-cart-count');
    if (navCartCount && window.cartManager) {
      const count = window.cartManager.cart ? window.cartManager.cart.item_count : 0;
      navCartCount.textContent = count;
      navCartCount.style.display = count > 0 ? 'inline-flex' : 'none';
    }

    // Update wishlist count
    const navWishlistCount = document.getElementById('nav-wishlist-count');
    if (navWishlistCount && window.wishlistManager) {
      const count = window.wishlistManager.items.length;
      navWishlistCount.textContent = count;
      navWishlistCount.style.display = count > 0 ? 'inline-flex' : 'none';
    }
  }
}

// ================================
// INITIALIZATION
// ================================

// ОПТИМИЗАЦИЯ: Инициализация плеера КАК МОЖНО РАНЬШЕ
// Используем MutationObserver чтобы не ждать DOMContentLoaded
(function initializeManagers() {
  let managersInitialized = false;

  function tryInitializeManagers() {
    // Проверяем наличие всех необходимых элементов
    const musicAudio = document.getElementById('music-audio');
    const musicPlayer = document.getElementById('music-player-toggle');
    const cartBtn = document.getElementById('floating-cart-btn');
    const wishlistBtn = document.getElementById('floating-wishlist-btn');

    // Если хотя бы музыкальный плеер готов - инициализируем его отдельно
    if (musicAudio && musicPlayer && !window.musicPlayer) {
      console.log('🎵 Early Music Player initialization...');
      window.musicPlayer = new MusicPlayer();
      console.log('✅ Music Player ready (early init)');
    }

    // Если все элементы готовы - инициализируем остальное
    if (musicAudio && musicPlayer && cartBtn && wishlistBtn && !managersInitialized) {
      console.log('🔧 Initializing all managers...');

      // Музыкальный плеер уже создан выше (или создаем если не успели)
      if (!window.musicPlayer) {
        window.musicPlayer = new MusicPlayer();
      }

      window.wishlistManager = new WishlistManager();
      window.cartManager = new CartManager();
      window.modalController = new ModalController();
      window.navigationController = new NavigationController();

      managersInitialized = true;
      console.log('✅ All managers initialized');
      return true;
    }

    return false;
  }

  // Попытка #1: Инициализировать немедленно (если элементы уже в DOM)
  if (tryInitializeManagers()) {
    return; // Успешно инициализировали
  }

  // Попытка #2: MutationObserver для РАННЕЙ инициализации
  // Отслеживает появление элементов БЕЗ ожидания полной загрузки страницы
  const observer = new MutationObserver(() => {
    if (tryInitializeManagers()) {
      observer.disconnect(); // Останавливаем наблюдение после успеха
    }
  });

  // Начинаем наблюдение за изменениями в DOM
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Fallback: Если через 2 секунды ничего не инициализировалось - ждем DOMContentLoaded
  setTimeout(() => {
    if (!managersInitialized) {
      console.warn('⚠️ Falling back to DOMContentLoaded...');
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryInitializeManagers);
      } else {
        tryInitializeManagers();
      }
    }
  }, 2000);
})();
